import styles from './playerDetails.module.css';
import CardContainer from '../cardContainer/cardContainer';
import GamblingIcon from '../../assets/exportableIcons/gamblingSession';
import { convertMinutesToCompactFormat } from '../../utils/helper';
import {
  PlayerDetailsATMUseCardProps,
  PlayerDetailsGamblingSessionsCardProps,
  PlayerDetailsSweepPresenceCardProps,
  ProcessedSweep,
  ProcessSweepDataResult,
} from './playerDetails.types';
import { Sweep, VisitActivityType } from '../../utils/helper.type';
import moment, { Moment } from 'moment';
import { Trans } from 'react-i18next';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import arrowDown from '../../assets/arrow_down.png';
import { Player, SweepStatus, VisitActivity, VisitType } from '@inplay/models';
import atmUse from '../../assets/exportableIcons/atmUse.svg';
import { HourlySweepStatus } from '../../pages/dashboard/dashboard.type';
import SweepIcon from '../../assets/exportableIcons/sweepIcon';
import check from '../../assets/check.png';

export const PlayerDetailsGamblingSessionsCard = ({
  isFirst,
  isExpanded,
  activity,
  handleExpandAll,
  allExpanded,
}: PlayerDetailsGamblingSessionsCardProps) => {
  const { isTablet } = useResponsiveLayout();
  return (
    <CardContainer
      className={`${styles.activityCard} ${isFirst && styles.firstCard} ${
        isExpanded && styles.expanded
      } `}
      background={
        isExpanded ? '' : 'bg-PLAYER_DETAIL_ACTIVITY_CARD_THEME_COLOR'
      }
    >
      <div className={styles.content}>
        {isFirst ? (
          <>
            <button
              className={styles.expandAll}
              onClick={() => handleExpandAll()}
            >
              <img
                src={arrowDown}
                alt=""
                className={`${allExpanded && styles.upArrow}`}
              />
            </button>
            <GamblingIcon height={isTablet ? 24 : 36} />
            <div className={styles.firstCardRight}>
              <div className={styles.title}>
                <Trans i18nKey="playerDetails.gamblingSessions" />
              </div>
              <div className={styles.data}>
                <div className={styles.label}>
                  <Trans i18nKey="playerDetails.currentSession" />:
                </div>
                <div className={styles.dataValue}>
                  {convertMinutesToCompactFormat(activity.timeInMinutes)}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={styles.title}>{activity.name}</div>
            <div className={styles.contentValue}>
              {convertMinutesToCompactFormat(activity.timeInMinutes)}{' '}
              {activity.endTime === null ? (
                <Trans i18nKey="playerDetails.ongoing" />
              ) : (
                ''
              )}
            </div>
          </>
        )}
      </div>
      {isExpanded && (
        <div className={styles.expandedContent}>
          {activity.type === VisitActivityType.SESSION ? (
            <>
              <div className={styles.expandedContentValue}>
                <Trans i18nKey="playerDetails.entry" /> -{' '}
                <Trans i18nKey="playerDetails.exit" />{' '}
                <span>
                  {moment(activity.startTime).format('hh:mm A')} -{' '}
                  {activity.endTime
                    ? moment(activity.endTime).format('hh:mm A')
                    : 'N/A'}
                </span>
              </div>
              <div className={styles.expandedContentValue}>
                <Trans i18nKey="playerDetails.miniBreaks" />:
                <span>
                  {activity.miniBreaks && activity.miniBreaks?.length > 0 ? (
                    activity.miniBreaks?.length +
                    ' (' +
                    Math.round(
                      activity.miniBreaks?.reduce(
                        (acc, curr) => acc + curr,
                        0,
                      ) / 60,
                    ) +
                    'm)'
                  ) : (
                    <Trans i18nKey="playerDetails.none" />
                  )}
                </span>
              </div>
            </>
          ) : (
            <>
              <div className={styles.expandedContentValue}>
                <Trans i18nKey="playerDetails.exit" /> -{' '}
                <Trans i18nKey="playerDetails.entry" />{' '}
                <span>
                  {moment(activity.startTime).format('hh:mm A')} -{' '}
                  {moment(activity.endTime).format('hh:mm A')}
                </span>
              </div>
            </>
          )}
        </div>
      )}
    </CardContainer>
  );
};

export const PlayerDetailsATMUseCard = ({
  isFirst,
  isExpanded,
  activity,
  handleExpandAll,
  allExpanded,
  isOnGoing,
}: PlayerDetailsATMUseCardProps) => {
  const { isTablet } = useResponsiveLayout();
  const duration: string = activity
    ? convertMinutesToCompactFormat(
        activity?.firstGamingSessionStartTime
          ? Math.round(
              (moment(activity.firstGamingSessionStartTime).unix() -
                moment(activity.startTime).unix()) /
                60,
            )
          : isOnGoing
            ? Math.round(
                (moment().unix() - moment(activity?.startTime).unix()) / 60,
              )
            : Math.round(
                (moment(activity?.endTime).unix() -
                  moment(activity?.startTime).unix()) /
                  60,
              ),
      )
    : '';

  return (
    <CardContainer
      className={`${styles.activityCard} ${isFirst && styles.firstCard} ${
        isExpanded && styles.expanded
      }`}
      background={
        isExpanded ? '' : 'bg-PLAYER_DETAIL_ACTIVITY_CARD_THEME_COLOR'
      }
    >
      <div className={styles.content}>
        {isFirst ? (
          activity ? (
            <>
              <button
                className={styles.expandAll}
                onClick={() => handleExpandAll()}
              >
                <img
                  src={arrowDown}
                  alt=""
                  className={`${allExpanded && styles.upArrow}`}
                />
              </button>
              <img src={atmUse} height={isTablet ? 24 : 36} alt="" />
              <div className={styles.right}>
                <div className={styles.title}>
                  <Trans i18nKey="playerDetails.atmWithdrawals" />
                </div>
                <div className={styles.data}>
                  <div className={styles.label}>{activity.name}:</div>
                  <div className={styles.value}>
                    {activity.poiClassification}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <img src={atmUse} height={isTablet ? 24 : 36} alt="" />
              <div className={styles.right}>
                <div className={styles.title}>
                  <Trans i18nKey="playerDetails.atmWithdrawals" />
                </div>
                <div className={styles.data}>
                  <div className={styles.label}>
                    <Trans i18nKey="playerDetails.noWithdrawals" />
                  </div>
                  <div className={styles.value}></div>
                </div>
              </div>
            </>
          )
        ) : (
          <>
            <div className={styles.title}>
              {moment(activity?.startTime).format('hh:mm A')}
            </div>
            <div className={styles.value}>{activity?.name}</div>
          </>
        )}
      </div>
      {isExpanded && activity && (
        <div className={styles.expandedContent}>
          {activity.visitType === VisitType.NONGAMING ? (
            <>
              <div className={styles.value}>
                <Trans i18nKey="playerDetails.timeSpentOutside" />:
              </div>
              <div className={styles.value}>
                {duration} ({moment(activity.startTime).format('hh:mm A')}
                {activity.firstGamingSessionStartTime ? (
                  ' - ' +
                  moment(activity.firstGamingSessionStartTime).format('hh:mm A')
                ) : isOnGoing ? (
                  <Trans i18nKey="playerDetails.ongoing" />
                ) : (
                  ' - ' + moment(activity.endTime).format('hh:mm A')
                )}
                )
              </div>
            </>
          ) : (
            <>
              <div className={styles.value}>
                <Trans i18nKey="playerDetails.atmBreakDuration" />: {duration} (
                {moment(activity.startTime).format('hh:mm A')}
                {activity.firstGamingSessionStartTime ? (
                  ' -' +
                  moment(activity.firstGamingSessionStartTime).format('hh:mm A')
                ) : isOnGoing ? (
                  <Trans i18nKey="playerDetails.ongoing" />
                ) : (
                  ' -' + moment(activity.endTime).format('hh:mm A')
                )}
                )
              </div>
            </>
          )}
        </div>
      )}
    </CardContainer>
  );
};

export const getGamingVisitTimes = (
  sessions: {
    startTime: string | Date;
    endTime?: string | Date | null;
  }[],
): {
  currentUninterruptedSession: number;
  totalTime: number;
  totalTimeOutside: number;
} => {
  if (sessions.length === 0) {
    return {
      currentUninterruptedSession: 0,
      totalTime: 0,
      totalTimeOutside: 0,
    };
  }

  const now: Date = new Date();

  const sortedSessions = [...sessions].sort(
    (a, b): number =>
      new Date(a.startTime).getTime() - new Date(b.startTime).getTime(),
  );

  const mergedSessions: { start: Date; end: Date }[] = [];

  sortedSessions.forEach(
    (current: {
      startTime: string | Date;
      endTime?: string | Date | null;
    }): void => {
      const start: Date = new Date(current.startTime);
      const end: Date = current.endTime ? new Date(current.endTime) : now;

      const last: { start: Date; end: Date } | undefined =
        mergedSessions[mergedSessions.length - 1];

      if (!last) {
        mergedSessions.push({ start, end });
        return;
      }

      const breakDuration: number =
        (start.getTime() - last.end.getTime()) / 60000;

      if (breakDuration < 3) {
        last.end = end;
      } else {
        mergedSessions.push({ start, end });
      }
    },
  );

  const totalTime: number = mergedSessions.reduce(
    (sum: number, session: { start: Date; end: Date }): number => {
      const duration: number =
        (session.end.getTime() - session.start.getTime()) / 60000;
      return sum + duration;
    },
    0,
  );

  const lastSession: { start: Date; end: Date } =
    mergedSessions[mergedSessions.length - 1];
  const currentUninterruptedSession: number =
    (lastSession.end.getTime() - lastSession.start.getTime()) / 60000;


  let totalTimeOutside = 0;
  for (let i = 1; i < mergedSessions.length; i++) {
    totalTimeOutside += (mergedSessions[i].start.getTime() - mergedSessions[i - 1].end.getTime()) / 60000;
  }
  return {
    currentUninterruptedSession: Math.round(currentUninterruptedSession),
    totalTime: Math.round(totalTime),
    totalTimeOutside: Math.round(totalTimeOutside),
  };
};

export const processSweepData = (
  playerID: string,
  sweepData: Sweep[],
  venueBranchInterval: number,
  visitActivities: VisitActivity[],
): ProcessSweepDataResult => {
  const hoursMap: Map<number, Sweep[]> = new Map();
  const allSweeps: Sweep[] = [];
  const now: Moment = moment();

  if (sweepData.length === 0) {
    return {
      processedData: [],
      currentConsecutiveSweeps: 0,
    };
  }

  sweepData.forEach((sweep: Sweep): void => {
    if (sweep.type !== 'Obligatory') return;

    const baseMoment: Moment = moment(sweep.scheduledTime || sweep.createdOn);
    const hourNumber: number = baseMoment.hour();

    if (!hoursMap.has(hourNumber)) hoursMap.set(hourNumber, []);
    hoursMap.get(hourNumber)?.push(sweep);

    allSweeps.push(sweep);
  });

  allSweeps.sort(
    (a: Sweep, b: Sweep) =>
      moment(a.createdOn).valueOf() - moment(b.createdOn).valueOf(),
  );

  let globalSweepNumber: number = 1;
  let hourSequenceNumber: number = 1;
  const processedData: ProcessedSweep[] = [];

  const sweepSlotsPerHour: number = 60 / venueBranchInterval;

  const formatHourRange = (hour: number): string => {
    const start: string = moment().hour(hour).minute(0).format('hh:mm A');
    const end: string = moment().hour(hour).minute(59).format('hh:mm A');
    return `${start} - ${end}`;
  };

  const sortedHours: number[] = Array.from(hoursMap.keys()).sort(
    (a, b) => a - b,
  );

  const flatSweepList: {
    status: SweepStatus;
    playerPresent: boolean;
    createdOn: Date;
  }[] = [];

  sortedHours.forEach((hour: number): void => {
    const sweepsInHour: Sweep[] = hoursMap.get(hour) || [];

    const sweepsBySlot: { [key: string]: Sweep } = {};

    sweepsInHour.forEach((sweep: Sweep): void => {
      const slotMoment: Moment = moment(sweep.scheduledTime || sweep.createdOn);
      const minutes: number = slotMoment.minutes();
      const slotIndex: number = Math.floor(minutes / venueBranchInterval);
      const slotKey: string = `${String(hour).padStart(2, '0')}:${String(
        slotIndex * venueBranchInterval,
      ).padStart(2, '0')}`;
      sweepsBySlot[slotKey] = sweep;
    });

    const hourStart: Moment = moment().hour(hour).minute(0).second(0);
    const hourEnd: Moment = moment(hourStart).add(1, 'hour');

    const filteredVisits: {
      start: Moment;
      end: Moment;
    }[] = visitActivities
      .filter(
        (v) =>
          v.location === 'GAMING' &&
          moment(v.endTime || now).isAfter(hourStart) &&
          moment(v.startTime).isBefore(hourEnd),
      )
      .map((v) => ({
        start: moment.max(moment(v.startTime), hourStart),
        end: moment.min(moment(v.endTime || now), hourEnd),
      }))
      .sort((a, b) => a.start.valueOf() - b.start.valueOf());

    let gamblingDuration: number = 0;
    let breakDuration: number = 0;

    for (let i = 0; i < filteredVisits.length; i++) {
      const visit: {
        start: moment.Moment;
        end: Moment;
      } = filteredVisits[i];
      gamblingDuration += visit.end.diff(visit.start, 'minutes');

      if (i > 0) {
        const gap = visit.start.diff(filteredVisits[i - 1].end, 'minutes');
        if (gap > 0) breakDuration += gap;
      }
    }

    const sweepsForHour: ProcessedSweep['sweeps'] = [];

    for (let index = 0; index < sweepSlotsPerHour; index++) {
      const minutes: number = index * venueBranchInterval;
      const scheduleMoment: Moment = moment()
        .hour(hour)
        .minute(minutes)
        .second(0);

      if (scheduleMoment.isAfter(now)) continue;

      const schedule: string = scheduleMoment.format('hh:mm A');
      const slotKey: string = `${String(hour).padStart(2, '0')}:${String(
        minutes,
      ).padStart(2, '0')}`;
      const sweep: Sweep | undefined = sweepsBySlot[slotKey];

      if (!sweep) continue;

      const player: Player | undefined = sweep.players.find(
        (p) => p.id === playerID,
      );
      const playerPresent: boolean = !!(player && player.presentDuringSweep);

      flatSweepList.push({
        status: sweep.status as SweepStatus,
        playerPresent,
        createdOn: moment(sweep.createdOn).toDate(),
      });

      sweepsForHour.push({
        id: sweep ? sweep._id : undefined,
        sweepNumber: globalSweepNumber++,
        sweepSchedule: schedule,
        sweepTime: moment(sweep.createdOn).toDate(),
        sweepStatus: sweep.status as SweepStatus & HourlySweepStatus,
        playerPresent,
      });
    }

    if (sweepsForHour.length > 0) {
      processedData.push({
        hourSequence: hourSequenceNumber++,
        hourRange: formatHourRange(hour),
        gamblingDurationInMinutes: Math.round(gamblingDuration).toString(),
        breakInMinutes: Math.round(breakDuration).toString(),
        sweeps: sweepsForHour.reverse(),
      });
    }
  });

  flatSweepList.sort((a, b) => b.createdOn.getTime() - a.createdOn.getTime());

  let currentConsecutiveSweeps: number = 0;
  for (const item of flatSweepList) {
    if (item.playerPresent) {
      currentConsecutiveSweeps++;
    } else {
      break;
    }
  }

  return {
    processedData,
    currentConsecutiveSweeps,
  };
};

export const PlayerDetailsSweepPresenceCard = ({
  isExpanded,
  isFirst,
  sweepsData,
  handleExpandAll,
  allExpanded,
  handleViewSweep,
}: PlayerDetailsSweepPresenceCardProps) => {
  const { isTablet } = useResponsiveLayout();
  return (
    <CardContainer
      className={`${styles.activityCard} ${isFirst && styles.firstCard} ${
        isExpanded && styles.expanded
      }`}
      background={
        isExpanded ? '' : 'bg-PLAYER_DETAIL_ACTIVITY_CARD_THEME_COLOR'
      }
    >
      <div className={styles.content}>
        {isFirst ? (
          <>
            <button
              className={styles.expandAll}
              onClick={() => handleExpandAll()}
            >
              <img
                src={arrowDown}
                alt=""
                className={`${allExpanded && styles.upArrow}`}
              />
            </button>
            <SweepIcon height={isTablet ? 24 : 36} />
            <div className={styles.right}>
              <div className={styles.title}>
                <Trans i18nKey="playerDetails.sweepPresence" />
              </div>
              <div className={styles.data}>
                <div className={styles.label}>
                  <Trans i18nKey="playerDetails.currentConsecutiveSweeps" />:
                </div>
                <div className={styles.value}>
                  {sweepsData?.hourSequence ?? 0}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className={styles.title}>
              {<Trans i18nKey="playerDetails.hour" />} {sweepsData.hourSequence}
            </div>
            <div className={styles.value}>
              {sweepsData.sweeps
                ? sweepsData.sweeps.filter((sweep) => sweep.playerPresent)
                    .length
                : 0}
              /3 {<Trans i18nKey="playerDetails.sweeps" />}
            </div>
          </>
        )}
      </div>
      {isExpanded && (
        <div className={`${styles.expandedContent} ${styles.sweepPresence}`}>
          <span className={styles.timeString}>{sweepsData.hourRange}</span>
          <div className={styles.divider}></div>
          {sweepsData?.sweeps &&
            sweepsData.sweeps.map((sweep, index) => {
              return (
                <>
                  <div className={styles.sweepRow} key={index}>
                    <div className={styles.details}>
                      {sweep.playerPresent ? (
                        <img src={check} alt="" />
                      ) : (
                        <div className={styles.cross}>✖</div>
                      )}{' '}
                      <Trans i18nKey="playerDetails.sweep" />{' '}
                      {sweep.sweepNumber} (
                      {sweep.sweepTime
                        ? moment(sweep.sweepTime).format('LT')
                        : sweep.sweepSchedule}
                      ):{' '}
                      {sweep.playerPresent ? (
                        <Trans i18nKey="playerDetails.present" />
                      ) : (
                        '-'
                      )}
                    </div>
                    {sweep.id && (
                      <div
                        className={'text-THEME_COLOR underline'}
                        onClick={() => handleViewSweep(sweep.id ?? '')}
                      >
                        View
                      </div>
                    )}
                  </div>
                  <div className={styles.divider}></div>
                </>
              );
            })}
          <div className={`${styles.timeInGaming} mt-2`}>
            <Trans i18nKey="playerDetails.timeInGambling" />:
            <span>
              {convertMinutesToCompactFormat(
                sweepsData.gamblingDurationInMinutes ?? 0,
              )}
            </span>
          </div>
          <div className={styles.timeInGaming}>
            <Trans i18nKey="playerDetails.breakDuration" />:
            <span>
              {convertMinutesToCompactFormat(sweepsData.breakInMinutes ?? 0)}
            </span>
          </div>
        </div>
      )}
    </CardContainer>
  );
};
